import * as React from "react";
import type { SVGProps } from "react";
const SvgLink = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M10.012 7.453H6.853a4.45 4.45 0 0 0-4.452 4.518 4.45 4.45 0 0 0 1.293 3.205c.857.87 1.96 1.333 3.14 1.333h3.159m3.995.038h3.159A4.451 4.451 0 0 0 21.6 12.03a4.54 4.54 0 0 0-1.314-3.186 4.4 4.4 0 0 0-3.139-1.332h-3.159m-6.736 4.447h9.476"
    />
  </svg>
);
export default SvgLink;
